import React from "react";
import classNames from "classnames";

export default function Content({ className, children }) {
  return <div className={classNames(className, "Content")}>{children}</div>;
}
